import Aura from "@primeuix/themes/aura";
import { definePreset } from '@primeuix/themes';

export const Velocity = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E7F6FD',
      100: '#CFEDFB',
      200: '#9FDBF6',
      300: '#6EC9F2',
      400: '#3EB7ED',
      500: '#0EA5E9',
      600: '#0B84BA',
      700: '#08638C',
      800: '#06425D',
      900: '#03212F',
      950: '#011017',
    },
  },
});

